import { createFileRoute } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { serviceBySlug } from "@/data/services";
import { breadcrumbSchema, faqSchema, jsonLd, serviceSchema, SITE_URL, absUrl } from "@/lib/seo";

const service = serviceBySlug["barnklippning-akersberga"];

export const Route = createFileRoute("/barnklippning-akersberga")({
  head: () => ({
    meta: [
      { title: service.seoTitle },
      { name: "description", content: service.metaDescription },
      { property: "og:title", content: service.seoTitle },
      { property: "og:url", content: absUrl(`${SITE_URL}${service.url}/`) },
    ],
    links: [{ rel: "canonical", href: absUrl(`${SITE_URL}${service.url}/`) }],
    scripts: [
      jsonLd(serviceSchema(service)),
      jsonLd(faqSchema(service.faq)),
      jsonLd(breadcrumbSchema([
        { name: "Hem", url: "/" },
        { name: "Barnklippning Stockholm", url: "/barnklippning-stockholm/" },
        { name: service.name, url: `${service.url}/` },
      ])),
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
